export const QUESTION_KEY_NAMES = ['area', 'constructionParts', 'wallConstructionType'] as const;
export const QUESTIONS = [
  {
    id: 1,
    keyName: 'area',
    question: 'エリア',
  },
  {
    id: 2,
    keyName: 'constructionParts',
    question: '工事箇所',
  },
  {
    id: 3,
    keyName: 'wallConstructionType',
    question: '工事内容',
  },
];
